import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

// css
import styles from "../setting.module.scss";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { CHANGE_PASSWORD } from "../../../../services/ApiCalls";
import { toast } from "react-toastify";

const schema = z
  .object({
    oldPassword: z
      .string()
      .trim()
      .min(1, { message: "Old Password is required" }),
    newPassword: z
      .string()
      .trim()
      .min(1, { message: "new Password is required" }),
    confirmPassword: z
      .string()
      .trim()
      .min(1, { message: "confirm Password is required" }),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "Passwords does not match",
  });

const ChangePassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    reValidateMode: "onChange",
    mode: "onChange",
  });

  const submitHandler = async (data) => {
    try {
      const resetRes = await CHANGE_PASSWORD(data);
      if (resetRes?.data?.status === "success") {
        toast.success(resetRes?.data?.message);
      } else {
        toast.error(resetRes?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit(submitHandler)}>
        <Row className="justify-content-center">
          <Col lg="12" className="my-2">
            <label
              htmlFor=""
              className={`${styles.formLabel} fw-sbold ps-2 ps-lg-3 mb-0 form-label`}
            >
              Enter Current Password
            </label>
            <input
              type="password"
              placeholder="Old Password"
              className={`${styles.formControl} form-control`}
              {...register("oldPassword")}
            />
            {
              <p className="errorColor">
                {errors?.oldPassword && errors.oldPassword.message}
              </p>
            }
          </Col>
          <Col lg="12" className="my-2">
            <label
              htmlFor=""
              className={`${styles.formLabel} fw-sbold ps-2 ps-lg-3 mb-0 form-label`}
            >
              Enter New Password
            </label>
            <input
              type="password"
              placeholder="New Password"
              className={`${styles.formControl} form-control`}
              {...register("newPassword")}
            />
            {
              <p className="errorColor">
                {errors?.newPassword && errors.newPassword.message}
              </p>
            }
          </Col>
          <Col lg="12" className="my-2">
            <label
              htmlFor=""
              className={`${styles.formLabel} fw-sbold ps-2 ps-lg-3 mb-0 form-label`}
            >
              Enter Confirm Password
            </label>
            <input
              type="password"
              placeholder="Confirm Password"
              className={`${styles.formControl} form-control`}
              {...register("confirmPassword")}
            />
            {
              <p className="errorColor">
                {errors?.confirmPassword && errors.confirmPassword.message}
              </p>
            }
          </Col>
          <Col lg="8" className="my-2 py-4">
            <Button
              className="d-flex align-items-center justify-content-center w-100 commonBtn"
              type="submit"
            >
              Save
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ChangePassword;
